export default {"src":"/_next/static/media/DeploymentManagement.38e3126b.svg","height":399,"width":790};